// Copyright (c) 2020 Comsearch, Inc., All rights reserved

import {
  PathStatusIdEnum,
  ProjectTypeIdEnum,
} from 'config/enums'

// Path Details - Administration section should be hidden
// when we're looking at Path Details for In Progress Engineering paths.

const hideAdminFieldsForThisPath = (projectTypeId, pathStatusId) => (
  projectTypeId === ProjectTypeIdEnum.ENGINEERING &&
  pathStatusId === PathStatusIdEnum.IN_PROGRESS
)

export default hideAdminFieldsForThisPath
